module.exports = __webpack_public_path__ + "img/bjwelcome.ca30137c.png";